import { postApi } from "../api/api";
import { xMerckApiKey } from "../constants/env";

let token, userId, sessionId;

export const getStoredToken = () => {
    if (!token) {
        const storedToken = sessionStorage.getItem('tokenValue');
        const storedExpiry = sessionStorage.getItem('tokenExpiry');
        if(storedToken && storedExpiry) {
            return {storedToken, storedExpiry};
        }
        
    }
    return token;
}

export const fetchToken = async (auth_string, data_string) => {
    return await postApi('/qoldecrypt', 
        {
            AUTH_STRING: auth_string,
            DATA_STRING: data_string
        }, 
        {
            userId: getUserId(),
            sessionId: getSessionId(),
            'X-Merck-APIKey': xMerckApiKey
            //'Access-Control-Allow-Origin': '*'
            //'x-apigw-api-id': 'phn78ucyjg'
        });
}

export const setTokenToStorage = (tokenValue, tokenExpiry) => {
    token = {storedToken: tokenValue, storedExpiry: tokenExpiry};
    sessionStorage.setItem('tokenValue', tokenValue);
    sessionStorage.setItem('tokenExpiry', tokenExpiry);
}



export const generateTokenRequest = () => {
    return {
        "APP_PLATFORM_ID": "DEV_TEST",
        "GROUP_CODE": "PO",
        "LOGIN_FLAG": "A",
        "OWNER_ACCOUNT_ID": "REACT2023-PO-DEV",
        "LOGIN_NAME": "Dev-React",
        "PWD_STRING": "A4vPezHQtxy8"
    }
}

export const generateTokenDataString = () => {
    return {
        "SESSION_ID": getSessionId(),
        "USER_ID": getUserId(),
        "MODULE_NAME": "petownerlogin",
        "DATA_JSON": ""
    }
}

export const getUserId = () => {
    if (userId) {
        return userId;
    }
    let storedUserId = sessionStorage.getItem('userId');
    if (!storedUserId) {
        storedUserId = createRandomString(5);
        sessionStorage.setItem('userId', storedUserId);
        userId = storedUserId;
    }
    return storedUserId;
}

export const getSessionId = () => {
    if (sessionId) {
        return sessionId;
    }
    let storedSessionId = sessionStorage.getItem('sessionId');
    if (!storedSessionId) {
        storedSessionId = createRandomString(8);
        sessionStorage.setItem('sessionId', storedSessionId);
        sessionId = storedSessionId;
    }
    return storedSessionId;
}

function createRandomString(length) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

